/**
 * Route for `affiliate-referral`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateReferralPage } from "../features/affiliate-referral/AffiliateReferralPage";

export const affiliateReferralRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-referral",
	component: AffiliateReferralPage,
});

export default affiliateReferralRoute;
